<template>
  <b-navbar fixed-top class="navbar is-primary">
    <template slot="brand">
      <router-link to="/" v-slot="{ href , isExactActive }">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img src="https://firebasestorage.googleapis.com/v0/b/cmsofferteclub.appspot.com/o/logo.svg?alt=media&token=4b774e51-1a11-4163-8412-1c9a9d1e57f7" />
        </b-navbar-item>
      </router-link>
    </template>
    <template slot="start">
      <router-link to="/new" v-slot="{ href , isExactActive }">
        <b-navbar-item :href="href" :active="isExactActive">Send coupon</b-navbar-item>
      </router-link>
      <router-link to="/your" v-slot="{ href, isExactActive }">
        <b-navbar-item :href="href" :active="isExactActive">Your coupons</b-navbar-item>
      </router-link>
      <router-link v-if="this.user.loggedIn" to="/profile" v-slot="{ href, isExactActive }">
        <b-navbar-item :href="href" :active="isExactActive">You profile</b-navbar-item>
      </router-link>
      <router-link v-if="!this.user.loggedIn" to="/reqaccess" v-slot="{ href, isExactActive }">
        <b-navbar-item :href="href" :active="isExactActive">Request access</b-navbar-item>
      </router-link>
      <b-navbar-item v-if="this.user.loggedIn" href="mailto:pietro@offerte.club">Support</b-navbar-item>
      <router-link v-if="this.user.data ? this.user.data.admin : false" to="/admin" v-slot="{ href, isExactActive }">
        <b-navbar-item :href="href" :active="isExactActive">Admin Panel</b-navbar-item>
      </router-link>
    </template>

    <template slot="end">
      <b-navbar-item href="#">{{this.user.data ? this.user.data.email : ''}}</b-navbar-item>
      <b-navbar-item tag="div">
        <div class="buttons">
          <b-button v-if="!this.user.loggedIn" @click="$router.push('login')">Login</b-button>
          <b-button v-if="this.user.loggedIn" @click="signOut">Logout</b-button>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";
import * as firebase from "firebase";
export default {
  name: "Navbar",
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "login"
          });
        });
    }
  }
};
</script>